import { styled, css } from '../../../../components-v4/theme';

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings.base};
    display: flex;
    gap: ${theme.spacings.base};
    width: 100%;

    ${theme.tokens.media.down('desktop')} {
      position: sticky;
      bottom: 0;
      flex-direction: column-reverse;
      gap: ${theme.spacings.xs};
    }
  `}
`;
